import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { State } from '../state';

import { AuthenticationActions } from './actions/authentication-actions';
import { DashboardActions } from './actions/dashboard-actions';
import { LegalActions } from './actions/legal-actions';
import { NavigationActions } from './actions/navigation-actions';
import { RegistrationActions } from './actions/registration-actions';
import { UserSettingsActions } from './actions/user-settings-actions';
import { TimelineExportActions } from './actions/timeline-export-actions';
import { SignalRConnectionActions } from './actions/signalr-connection-actions';
import { TrendExportActions } from './actions/trend-export-actions';
import { AlarmAcknowledgementActions } from './actions/alarm-action';
import { SiteActions } from './actions/site-actions';
import { SierraDeviceActions } from './actions/sierra-device-actions';
import { PxdbDeviceActions } from './actions/pxdb-device-actions';
import { TrendChannelActions } from './actions/trend-channels-actions';
import { MeshDeviceActions } from './actions/mesh-device-actions';
import { GetSubscriptionActions } from './actions/get-subscription-actions';
import { GetOrgActions } from './actions/get-org-type-action';

import { AlarmSuggestionAcceptRejectActions } from './actions/alarm-suggestion-actions';
import { ResetSuggestionActions } from './actions/reset-suggestion-actions';
import { SensorDetailsActions } from './actions/sensor-detail-actions';
import { StarfishDeviceActions } from './actions/starfish-device-actions';
import { ManageAlarmsActions } from './actions/manage-alarms-actions';
import { ManageDeviceProfilesActions } from './actions/manage-device-profiles-actions';

export const Actions = {
    Alarm: AlarmAcknowledgementActions,
    AlarmSuggestion: AlarmSuggestionAcceptRejectActions,
    Authentication: AuthenticationActions,
    Dashboard: DashboardActions,
    Legal: LegalActions,
    Navigation: NavigationActions,
    Registration: RegistrationActions,
    UserSettings: UserSettingsActions,
    TimelineExport: TimelineExportActions,
    SignalRConnection: SignalRConnectionActions,
    TrendExport: TrendExportActions,
    Site: SiteActions,
    SierraDevices: SierraDeviceActions,
    PxdbDevices: PxdbDeviceActions,
    MeshDevices: MeshDeviceActions,
    StarfishDevices: StarfishDeviceActions,
    TrendChannels: TrendChannelActions,
    GetSubscription: GetSubscriptionActions,
    GetOrgCheck: GetOrgActions,
    ResetSuggestion: ResetSuggestionActions,
    SensorDetailsActions: SensorDetailsActions,
    ManageAlarmsActions: ManageAlarmsActions,
    ManageDeviceProfilesActions: ManageDeviceProfilesActions,
};

export type Actions =
    | AuthenticationActions
    | AlarmAcknowledgementActions
    | AlarmSuggestionAcceptRejectActions
    | DashboardActions
    | LegalActions
    | NavigationActions
    | RegistrationActions
    | UserSettingsActions
    | SignalRConnectionActions
    | SiteActions
    | TimelineExportActions
    | TrendExportActions
    | SierraDeviceActions
    | PxdbDeviceActions
    | MeshDeviceActions
    | GetSubscriptionActions
    | GetOrgActions
    | TrendChannelActions
    | ResetSuggestionActions
    | SensorDetailsActions
    | StarfishDeviceActions
    | ResetSuggestionActions
    | ManageAlarmsActions
    | ManageDeviceProfilesActions;

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, State, null, Action<Actions['type']>>;
